import { getIn } from "formik";
import React from "react";
import { RadioButton } from "@vwfs-bronson/bronson-react";

function RadioButtonField({ field, form, ...props }) {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);
  const curVal = getIn(form.values, field.name);

  return (
    <RadioButton
      {...props}
      {...field}
      checked={curVal === field.value}
      error={touched && !!error}
    >
      {props.label}
    </RadioButton>
  );
}

export { RadioButtonField };
